/*
* SelectReducer
*/

import { fromJS } from 'immutable';
import { UPDATE_OPTION, UPDATE_MODAL_OPTION } from './constants';

// The initial state of the App
export const initialState = fromJS({
  option: 'today',
  modalOption: 'today',
});

function selectReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_OPTION:
      return state.set('option', action.option);
    case UPDATE_MODAL_OPTION:
      return state.set('modalOption', action.option);
    default:
      return state;
  }
}

export default selectReducer;
